var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollArrowBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st1 {\n        fill: #0096d9;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 30,
    cy: 27,
    r: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.6,21.5c.2-.2.4-.3.6-.3s.4,0,.6.2l10.3,9.4,10.3-9.4c.3-.3.9-.3,1.2,0,.3.3.3.9,0,1.2l-10.8,10c-.3.3-.8.3-1.1,0l-10.8-10c-.3-.3-.4-.8,0-1.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollArrowBlue);
export default __webpack_public_path__ + "static/media/scroll-arrow-blue.ae3d94f04acbb99260d7adb3c1974270.svg";
export { ForwardRef as ReactComponent };